// extracted by mini-css-extract-plugin
export default {"input-box":"Input_input-box__N+JH2","input-wrapper":"Input_input-wrapper__Fpgil"};